import { CandleBreakData } from '../tactics/entryTactics/candleBreak/candleBreakData';
import { LimitOrderData } from '../tactics/entryTactics/limitOrder/limitOrderData';
import { MarketOrderData } from '../tactics/entryTactics/marketOrder/marketOrderData';
import { AtrTrailData } from '../tactics/exitTactics/atrTrail/atrTrailData';
import { BreakPriceData } from '../tactics/exitTactics/breakPrice/breakPriceData';
import { CandleMagnitudeData } from '../tactics/exitTactics/candleMagnitude/candleMagnitudeData';
import { CandleTrailData } from '../tactics/exitTactics/candleTrail/candleTrailData';
import { GrabCentsData } from '../tactics/exitTactics/grabCents/grabCentsData';
import { GreenToRedCandlesData } from '../tactics/exitTactics/greenToRedCandles/greenToRedCandlesData';
import { GreenToRedPositionsData } from '../tactics/exitTactics/greenToRedPositions/greenToRedPositionsData';
import { LossLimitData } from '../tactics/exitTactics/lossLimit/lossLimitData';
import { MfeRetracementData } from '../tactics/exitTactics/mfeRetracement/mfeRetracementData';
import { PositionBreakPriceData } from '../tactics/exitTactics/positionBreakPrice/positionBreakPriceData';
import { PositionPriceTrailData } from '../tactics/exitTactics/positionPriceTrail/positionPriceTrailData';
import { PreserveProfitData } from '../tactics/exitTactics/preserveProfit/preserveProfitData';
import { RatchetBracketData } from '../tactics/exitTactics/ratchetBracket/ratchetBracketData';
import { UnderlyingBreakPriceData } from '../tactics/exitTactics/underlyingBreakPrice/underlyingBreakPriceData';
import { UnderlyingPriceExitData } from '../tactics/exitTactics/underlyingPriceExit/underlyingPriceExitData';
import { UnderlyingPriceTrailData } from '../tactics/exitTactics/underlyingPriceTrail/underlyingPriceTrailData';
import { AddToWinnerData } from '../tactics/positionTactics/addToWinner/addToWinnerData';
import { ScalingInData } from '../tactics/positionTactics/scalingIn/scalingInData';
import { EmaIntersectsFirstCandleData } from '../tactics/setupFilters/emaIntersectsFirstCandle/emaIntersectsFirstCandleData';
import { FtfcData } from '../tactics/setupFilters/ftfc/ftfcData';
import { PriceIntersectsFirstCandleData } from '../tactics/setupFilters/priceIntersectsFirstCandle/priceIntersectsFirstCandleData';
import { TimeOfDayData } from '../tactics/setupFilters/timeOfDay/timeOfDayData';
import { AdHocData } from '../tactics/setups/adHoc/addHocData';
import { BounceData } from '../tactics/setups/bounce/bounceData';
import { BounceEmaData } from '../tactics/setups/bounceEma/bounceEmaData';
import { BreakData } from '../tactics/setups/break/breakData';
import { BreakCandleTypeData } from '../tactics/setups/breakCandleType/breakCandleTypeData';
import { BreakEmaData } from '../tactics/setups/breakEma/breakEmaData';
import { CandlePatternData } from '../tactics/setups/candlePattern/candlePatternData';
import { CandleTriggerData } from '../tactics/setups/candleTrigger/candleTriggerData';
import { ConvictionCandleData } from '../tactics/setups/convictionCandle/convictionCandleData';
import { FlagData } from '../tactics/setups/flag/flagData';
import { OrbData } from '../tactics/setups/orb/orbData';

export type DataStoreMap = {
  [index: string]: any;
};
export const dataStoreMap: DataStoreMap = {
  //setups
  CANDLE_PATTERN: CandlePatternData,
  BREAK: BreakData,
  BOUNCE: BounceData,
  CONVICTION_CANDLE: ConvictionCandleData,
  CANDLE_TRIGGER: CandleTriggerData,
  BREAK_CANDLE_TYPE: BreakCandleTypeData,
  ORB: OrbData,
  BOUNCE_EMA: BounceEmaData,
  BREAK_EMA: BreakEmaData,
  FLAG: FlagData,
  AD_HOC: AdHocData,

  //setup filters
  FTFC: FtfcData,
  FTFC_FILTER: FtfcData,
  TIME_OF_DAY: TimeOfDayData,
  PRICE_INTERSECTS_FIRST_CANDLE: PriceIntersectsFirstCandleData,
  EMA_INTERSECTS_FIRST_CANDLE: EmaIntersectsFirstCandleData,

  //entry tactics
  MARKET_ORDER: MarketOrderData,
  LIMIT_ORDER: LimitOrderData,
  CANDLE_BREAK: CandleBreakData,

  //position
  SCALING_IN: ScalingInData,
  ADD_TO_WINNER: AddToWinnerData,

  //exits
  BREAK_PRICE: BreakPriceData,
  CANDLE_TRAIL: CandleTrailData,
  GRAB_CENTS: GrabCentsData,
  GREEN_TO_RED_CANDLES: GreenToRedCandlesData,
  GREEN_TO_RED_POSITIONS: GreenToRedPositionsData,
  LOSS_LIMIT: LossLimitData,
  POSITION_PRICE_TRAIL: PositionPriceTrailData,
  PRESERVE_PROFIT: PreserveProfitData,
  UNDERLYING_PRICE_TRAIL: UnderlyingPriceTrailData,
  RATCHET_BRACKET: RatchetBracketData,
  UNDERLYING_BREAK_PRICE: UnderlyingBreakPriceData,
  CANDLE_MAGNITUDE: CandleMagnitudeData,
  ATR_TRAIL: AtrTrailData,
  MFE_RETRACEMENT: MfeRetracementData,
  UNDERLYING_PRICE_EXIT: UnderlyingPriceExitData,
  POSITION_BREAK_PRICE: PositionBreakPriceData,
  FLATTEN_BEFORE_MARKET_CLOSE: null,
};
